/** @format */

import React, {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';

export const Modal = props => {
    const {
        bodyHeightAuto,
        className = '',
        bodyStyle,
        maxWidth,
        children,
        onClose,
        zIndex,
        isOpen,
        style
    } = props;

    const bodyMinHeight = bodyHeightAuto ? 'auto' : '';

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'auto';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    const scrollRef = useRef(null);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [isOpen]);

    const enhancedChildren = React.Children.map(children, child => {
        if (child.type.name !== 'ModalHeader' && child.type.name !== 'ModalFooter') return child;
        return React.cloneElement(child, {onClose});
    });

    if (!isOpen) return null;

    return createPortal(
        <div
            className={`${className} modal-45jd__backdrop`}
            style={{...style, zIndex: zIndex || 1000}}
            onClick={onClose}>
            <div
                className="modal-45jd__content"
                onClick={e => e.stopPropagation()}
                style={{...bodyStyle, minHeight: bodyMinHeight, maxWidth}}>
                {enhancedChildren}
            </div>
        </div>,
        document.body
    );
};

export const ModalHeader = ({children, onClose, ...restOfProps}) => {
    const isChildrenString = typeof children === 'string';

    return (
        <div
            className={'modal-45jd__header d-flex align-items-center justify-content-between'}
            {...restOfProps}>
            <div className="w-100">
                {isChildrenString ? (
                    <h4 className="modal-header-45jd__title">{children}</h4>
                ) : (
                    children
                )}
            </div>
            {onClose && (
                <button
                    className="modal-header-45jd__close flex-shrink-0 d-flex align-items-center justify-content-center p-0 m-0"
                    onClick={onClose}>
                    <i className="fa fa-close" />
                </button>
            )}
        </div>
    );
};

export const ModalFooter = ({children, onClose, ...restOfProps}) => {
    return (
        <div className={'modal-45jd__footer'} {...restOfProps}>
            {children}
            {!children && (
                <div className="d-flex align-items-center justify-content-end">
                    <button
                        onClick={onClose}
                        className="btn btn--secondary d-flex align-items-center justify-content-center">
                        Close
                    </button>
                </div>
            )}
        </div>
    );
};
